import React, {PropTypes} from 'react';
import Icon from '../../icons/icon.jsx';
import {icons} from '../../icons/constants.js';
import Translator from 'bazinga-translator';

const Dashboard = (props) => {
    const {results} = props;

    const classes = (type, unread) => {
        if (unread === true) {
            return `c-activity-feed__item c-activity-feed__item--${type} is-unread`;
        } else {
            return `c-activity-feed__item c-activity-feed__item--${type}`;
        }
    };

    return (
        <table className="js-notifications-table js-notifications-table-dashboard c-activity-feed c-activity-feed--dashboard">
            <tbody>
            {
                results.activities.map((activity) => {
                    return (
                        <tr key={activity.id}
                            className={classes(activity.typeIcon,activity.isUnread)}>
                            <td className="c-activity-feed__when">
                                <time className="c-activity-feed__time">{activity.time}</time>
                                <time className="c-activity-feed__date">{activity.date}</time>
                            </td>

                            <td className="c-activity-feed__esti-details">
                                <a href={activity.titleURL}><h3>{activity.title}</h3></a>
                                <div>
                                    {(activity.clientURL) ?
                                        <p className="c-activity-feed__esti-client">
                                            {Translator.trans('activity_feed.client', [], 'app')} <a href={activity.clientURL}
                                               className="c-activity-clientUrl">{activity.client}</a>
                                        </p> : null
                                    }
                                    <p className="c-activity-feed__esti-date">{Translator.trans('activity_feed.created', [], 'app')} <span>{activity.crdate}</span>
                                    </p>
                                    <p>{Translator.trans('activity_feed.ip', [], 'app')} <span>{activity.ip}</span></p>
                                </div>
                            </td>

                            <td className="c-activity-feed__ip">

                                <div>
                                    <div className="tooltip">
                                        <Icon icon={icons.globe}
                                              color="#00FF00"
                                              width={32}
                                              height={32}/>
                                        <div className="tooltip__text">{activity.userAgent}
                                        </div>
                                    </div>
                                </div>

                                <p>IP address: <span>{activity.ip}</span></p>

                            </td>

                            <td className="c-activity-feed__opt">
                                <a href={activity.previewURL}
                                   title={Translator.trans('activity_feed.preview', [], 'app')} target="_blank"><Icon icon={icons.preview}
                                                         color="#332F36"
                                                         width={22}
                                                         height={22}/></a>
                                <a href={activity.titleURL}
                                   title={Translator.trans('activity_feed.edit_mode', [], 'app')}><Icon icon={icons.edit}
                                                           color="#332F36"
                                                           width={20}
                                                           height={22}/></a>
                            </td>

                            <td className="c-activity-feed__message">
                                <h5>{activity.typeLabel}</h5>
                            </td>
                            <td className="c-activity-feed__icon">
                                <div className="c-activity-feed__svg"></div>
                                <div className="c-activity-feed__svg c-activity-feed__svg--active"></div>
                            </td>

                        </tr>
                    );
                })
            }
            </tbody>
            <tfoot>
            <tr className="table__empty table__empty--nodata">
                <td>
                    <div>
                        <div className="table__empty__text">
                            <h2>{Translator.trans('activity_feed.empty_header', [], 'app')}</h2>
                            <p>{Translator.trans('activity_feed.empty_text', [], 'app')}</p>
                            <a href="/panel/estimations/add" className="btn">{Translator.trans('activity_feed.empty_button', [], 'app')}</a>
                        </div>
                        <div className="table__empty__image"></div>
                    </div>
                </td>
            </tr>
            </tfoot>
        </table>
    );
};

Dashboard.propTypes = {
    results: PropTypes.object.isRequired,
};

export default Dashboard;



// WEBPACK FOOTER //
// ./src/_app/activity-feed/components/Dashboard.jsx